import Fontstyles from 'styles/Fonts.module.scss';
import Image from 'core/image';
import phoneIcon from 'static/img/icons/CECA_Home_Icon_Phone.svg';
import pigIcon from 'static/img/icons/CECA_Home_Icon_Pig.svg';
import PropTypes from 'prop-types';
import shieldIcon from 'static/img/icons/CECA_Home_Icon_Shield.svg';
import styles from 'styles/HeaderSection.module.scss';
import { usePageInfo } from 'context/PageInfoContext';
import useRichTranslation from 'hooks/useRichTranslation';

const DisplayText = ({ bannerType = 'landing' }) => {
    const t = useRichTranslation('header');
    const { pageInfo } = usePageInfo();

    if (bannerType === 'landing') {
        return (
            <>
                <h1 className={styles.title}>{t('display-text.title')}</h1>
                <div className={`${styles.display_item_list} ${styles.display_item_description}`}>
                    <p className={Fontstyles.text_subtitle}>
                        {t('display-text.description')}
                    </p>
                </div>
            </>
        );
    }
    if (bannerType === 'old-landing') {
        return (
            <>
                <h1 className={styles.small_title}>{pageInfo.page_context.meta_title}</h1>
                <div className={`${styles.display_item_list} ${styles.display_item_description}`}>
                    <p className={Fontstyles.text_header5}>
                        {t('display-text.description')}
                    </p>
                </div>
            </>
        );
    }

    return (
        <>
            <h1>{t('display-text.title')}</h1>
            <div className={styles.display_item_list}>
                <p className={Fontstyles.text_normal}>
                    <Image height={30} width={40} src={shieldIcon} />
                    {t('display-text.item-list.first-item')}
                </p>
                <p className={Fontstyles.text_normal}>
                    <Image height={30} width={40} src={phoneIcon} />
                    {t('display-text.item-list.second-item')}
                </p>
                <p className={Fontstyles.text_normal}>
                    <Image height={30} width={40} src={pigIcon} />
                    {t('display-text.item-list.third-item')}
                </p>
            </div>
        </>
    );
};

DisplayText.propTypes = {
    bannerType: PropTypes.string
};

export default DisplayText;
